/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../components/ui-elements/table/StyledTableRow';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { getAllAccess } from '../../../../../store/reducers/access/accessAction';
import { IconButton, Pagination, Stack } from '@mui/material';
import RefreshIcon from "@mui/icons-material/Refresh";

const AccessViewList = () => {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const AccessViewList = useSelector(state => state.access.accessList);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    // Calculate paginated records
    const paginatedRecords = React.useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return AccessViewList?.Records?.slice(startIndex, startIndex + itemsPerPage) || [];
    }, [AccessViewList, currentPage]);

    // Handle next/previous page
    const totalPages = Math.ceil((AccessViewList?.Records?.length || 0) / itemsPerPage);
    const fetchAccess = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllAccess
                ()).unwrap();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchAccess()
    }, [fetchAccess]);

    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="ID" />
                            <StyledTableCell label="Type" />
                            <StyledTableCell label="Detail" />
                            <StyledTableCell label="Identity Provider" />

                            <StyledTableCell label="GetChkd ID" />
                            <StyledTableCell label="Organization   ID" />

                            <StyledTableCell label="Organization Application ID" />
                            <StyledTableCell label="Access Date" />
                            <StyledTableCell label=" " align="right">
                                <IconButton onClick={fetchAccess} color="secondary"  >
                                    <RefreshIcon sx={{ fontSize: 30 }} />
                                </IconButton>
                            </StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedRecords.map((row) => {
                            return (
                                <StyledTableRow key={row.recordID}>
                                    <StyledTableCell label={row.recordID} />
                                    <StyledTableCell label={`${row.accessType ?? "N/A"}  `} />
                                    <StyledTableCell label={row.accessDetail ?? "N/A"} />
                                    <StyledTableCell label={row.accessAuthProvider ?? "N/A"} />

                                    <StyledTableCell label={row.getChkdID ?? "N/A"} />
                                    <StyledTableCell label={row.organizationID ?? "N/A"} />
                                    <StyledTableCell label={row.organizationApplicationID ?? "N/A"} />
                                    <StyledTableCell label={row.accessDate ?? "N/A"} />
                                    <StyledTableCell label="" />

                                </StyledTableRow>);
                        })}
                    </TableBody>
                </Table>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={(_, page) => setCurrentPage(page)}
                        variant="outlined"
                        shape="rounded"
                        color="primary"
                        size="large"
                    />
                </Stack>
            </TableContainer> : (<Loader />)}

        </>
    )

}

export default AccessViewList;
